module.exports = __webpack_public_path__ + "static/media/US.0465da9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/US.svg
// module id = 384
// module chunks = 0